const eventNamespace = 'worker_marketing_preferences_form'

export const trackingEvents = {
  CONSENT_CHANGE: `${eventNamespace}.consent.changed`,
}
